export var ShapeArcMode;
(function (ShapeArcMode) {
    /**
     * 随机
     */
    ShapeArcMode[ShapeArcMode["RANDOM"] = 0] = "RANDOM";
    /**
     * 单向循环
     */
    ShapeArcMode[ShapeArcMode["UNIDIRECTIONAL_CYCLE"] = 1] = "UNIDIRECTIONAL_CYCLE";
    /**
     * 双向循环
     */
    ShapeArcMode[ShapeArcMode["BIDIRECTIONAL_CYCLE"] = 2] = "BIDIRECTIONAL_CYCLE";
    /**
     * 均匀爆发
     */
    ShapeArcMode[ShapeArcMode["UNIFORM_BURST"] = 3] = "UNIFORM_BURST";
})(ShapeArcMode || (ShapeArcMode = {}));
